// extracted by mini-css-extract-plugin
export default {"status-badge__container":"styles_status-badge__container__fgLRI"};